import '../../../../Pages/BasketPage.css'

import { useEffect, useState, useRef } from 'react'
import ProductBuyBtn from './ProductBuyBtn';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';
import useHandleAddToBasketBtn from '../../Hooks/useHandleAddToBasketBtn';
import FavoriteStar from '../../../../Components/Components/FavoriteStar';
import { CapitalizeFirstLowercaseRest } from '../../../../Helpers/CustomConverter';
import { useCart } from '../../../../Providers/CartProvider';
import { RxCross2 } from "react-icons/rx";
import ProductThreshold from '../../../../Components/Components/ProductThreshold';
import ProductAvailabilityLevel from '../../../../Components/Components/ProductAvailabilityLevel';
import useGetProductIndexWithMask from '../../../../Components/BasketPage/Hooks/useGetProductIndexWithMask';
import NewPromoSellOutTag from '../../../../Components/Components/NewPromoSellOut/NewPromoSellOutTag';
import { useOffers } from '../../../../Providers/OffersProvider';
import { useShop } from '../../../../Providers/ShopProvider';
import useGetProductImage from '../../../../Hooks/useGetProductImage';
import useCommonFunctions from '../../Hooks/MobileAndDesktopCommon/useCommonFunctions';
import { useParams } from '../../../../Providers/ParamsProvider';
import { getIndeksHeader } from '../../../../Helpers/ValidatorHelper';
import OtherProducts from './OtherProducts';
import ProductBuyBtnForRealizedOffer from './ProductBuyBtnForRealizedOffer';
import { useSavedBaskets } from '../../../../Providers/SavedBasketsProvider';
import { useLocation } from 'react-router-dom';

/**
 * DK : Komponent główny wyświetlający produkt
 * @param {object} product - Produkt
 * @param {boolean} isBasketSummary - Czy jest to podsumowanie koszyka (przekaż setLockProceed jeżeli true)
 * @param {object} additionalOptions - Parametry gdy potrzebujemy checkboxa oraz usuwanie { handleSelectProduct, handleUnselectProduct, handleRemoveClick, isCheckboxSelected } 
 * @param {object} setLockProceed - ustawienie blokady przejścia w podsumowaniu koszyka
 * @param {boolean} blockSetPriceFromBasket - Blokuje ustawienie ceny z koszyka na lost focus inputa z ilością
 * @param {boolean} isSavedBasket - Wejście z zapisanych koszyków
 * @param {Array} unavailableProductsList - Lista niedostępnych produktów w wybranym OTD
 */
const Product = ({ product, isBasketSummary, additionalOptions, setLockProceed, blockSetPriceFromBasket, isSavedBasket, handleAddToCartFromSavedBasket, unavailableProductsList }) => {
    const location = useLocation()
    const timerRef = useRef(null)

    const { GetProductQuantityInCart, cartItems } = useCart()
    const [quantityInCart, setQuantityInCart] = useState(0)
    const [quantity, setQuantity] = useState(0)
    const { handleBtnOnClick } = useHandleAddToBasketBtn(product, quantity);
    const [isSelected, setIsSelected] = useState(additionalOptions ? additionalOptions.isCheckboxSelected : false) //DK : Dodatkowe opcje z których zrezygnowało TG
    const [isAvailabilityLevelAdditionalInfoShowed, setIsAvailabilityLevelAdditionalInfoShowed] = useState(false)
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const { savedOfferId, getProductQuantityInSavedOffer, selectedSavedOffer, orderItemsFromOffer, setOrderItemsFromOffer } = useOffers()
    const { selectedSavedBasket, getProductQuantityInSavedBasket } = useSavedBaskets()
    const { activeCategory } = useShop()
    const { GetProductImage } = useGetProductImage()
    const productRef = useRef(null)
    const [productWidth, setProductWidth] = useState(null)
    const { handleProductRedirect } = useCommonFunctions()
    const { isMobile, license } = useParams()

    useEffect(() => {
        if (savedOfferId != -1) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
        else if (selectedSavedBasket) {
            setQuantityInCart(getProductQuantityInSavedBasket(product))
        }
        else {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [[], savedOfferId, selectedSavedBasket])

    useEffect(() => {
        // if (!isSavedBasket) {
        //     let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        //     setQuantity(qtyToShow)
        // }
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow)
    }, [quantityInCart])

    useEffect(() => {
        //DK: Update koszyka po sekundzie od skończenia manipulacją ilościami        
        if (isBasketSummary) {
            setLockProceed(true)
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
            timerRef.current = setTimeout(() => {
                handleBtnOnClick('update')
                setLockProceed(false)
            }, 1000)
        }
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
            }
        }
    }, [quantity])

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [cartItems])

    useEffect(() => {
        if (savedOfferId != -1 && selectedSavedOffer && selectedSavedOffer.basketItems) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [selectedSavedOffer])

    useEffect(() => {
        if (productRef.current) {
            const width = productRef.current.offsetWidth;
            setProductWidth(width);
        }
    }, [])

    const OnChange = (e) => {
        let value = e.target.value
        setQuantity(value)
    }

    const generateFirstModule = () => {
        let divStyle = additionalOptions ? 'd-flex align-items-center ' : 'mb-auto'
        if (orderItemsFromOffer && orderItemsFromOffer.length > 0) {
            return null
        }
        return (
            <div className={`col-auto ms-2 ${divStyle}`}>
                {additionalOptions ?
                    // (<CheckBox
                    //     className="custom-checkbox"
                    //     value={isSelected}
                    //     onValueChange={(value) => handleCheckBoxValueChange(value)}
                    // />) DK : Dodatkowe opcje z których zrezygnowało TG
                    null
                    :
                    (<FavoriteStar
                        isFavorite={product.isFavorite}
                        index={product.index}
                    />)
                }
            </div>
        )
    }

    const handleCheckBoxValueChange = async (value) => {
        if (isBasketSummary) {
            setLockProceed(true)
        }
        if (value) {
            await additionalOptions.handleSelectProduct(product.index, quantity)
        }
        else {
            await additionalOptions.handleUnselectProduct(product.index)
        }
        setIsSelected(prev => !prev)
        if (isBasketSummary) {
            setLockProceed(false)
        }
    }

    const handleRemoveButtonClick = () => {
        if (orderItemsFromOffer && orderItemsFromOffer.length) {
            setOrderItemsFromOffer(prevItems =>
                prevItems.filter(item => item.artNo !== product.index)
            )
        }
        else {
            additionalOptions.handleRemoveClick(product)
        }
    }

    const generateFirstModuleForMobile = () => {
        if (orderItemsFromOffer && orderItemsFromOffer.length > 0) {
            return null
        }
        else if (additionalOptions) {
            // return <CheckBox
            //     className="custom-checkbox"
            //     value={isSelected}
            //     onValueChange={(value) => handleCheckBoxValueChange(value)}
            // />  DK : Dodatkowe opcje z których zrezygnowało TG
            return null
        }
        else {
            return <FavoriteStar
                isFavorite={product.isFavorite}
                index={product.index}
                size={22}
            />
        }
    }

    let producerText = product.producent && product.producent.length > 1 ? product.producent : ''
    let borderColor = location.pathname.toLowerCase() === "/cart" && (unavailableProductsList && unavailableProductsList.includes(product.index)) ? 'rgb(216, 27, 36)' : ''

    if (isMobile) {
        return (<div className="newProduct" style={{ borderColor: borderColor }}>
            <div className="row mt-2 mb-3">
                <div className="col-6 d-flex justify-content-start ps-3">
                    {generateFirstModuleForMobile()}
                </div>
                <div className="col-6 d-flex justify-content-end pe-3">
                    {additionalOptions && <RxCross2 size={25} style={{ cursor: 'pointer' }} onClick={() => additionalOptions.handleRemoveClick(product)} />}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-auto">
                    <div className='cart-product-img' onClick={() => handleProductRedirect(product.index, isAvailabilityLevelAdditionalInfoShowed, activeCategory)}
                        style={{ cursor: 'pointer' }}>
                        <GetProductImage
                            photoFileName={product.photoFileNames[0]}
                        />
                    </div>
                </div>
                <div className="col">
                    <div className="row element-pointer" onClick={() => handleProductRedirect(product.index, isAvailabilityLevelAdditionalInfoShowed, activeCategory)}>
                        <div className='d-flex p-0 mb-2'>
                            <NewPromoSellOutTag
                                product={product}
                                isBigTag={false}
                            />
                        </div>
                        <span className="secondary-text" >{producerText}</span>
                        <span className="mobile-font">{CapitalizeFirstLowercaseRest(product.title)}</span>
                        <span className='secondary-text mt-2' style={{ minHeight: '50px' }}>{CapitalizeFirstLowercaseRest(product.label)}</span>
                        <span className="secondary-text mt-2">{`${getIndeksHeader(license)}: ${getProductIndexWithMask(product.index)}`}</span>
                        <span className="secondary-text mt-1">{`Indeks producenta: ${product.producentArtNo}`}</span>
                    </div>
                    <div className="row mt-2">
                        <ProductAvailabilityLevel
                            product={product}
                            setIsAvailabilityLevelAdditionalInfoShowed={setIsAvailabilityLevelAdditionalInfoShowed}
                        />
                    </div>
                    <div className="row mt-3 mb-3">
                        {orderItemsFromOffer && orderItemsFromOffer.length > 0 ?
                            (<ProductBuyBtnForRealizedOffer
                                product={product}
                            />)
                            :
                            (<ProductBuyBtn
                                product={product}
                                quantityInCart={quantityInCart}
                                quantity={quantity}
                                setQuantity={setQuantity}
                                OnChange={OnChange}
                                onClick={handleBtnOnClick}
                                isBasketSummary={isBasketSummary}
                                isProductDetail={false}
                                blockSetPriceFromBasket={blockSetPriceFromBasket}
                                isSavedBasket={isSavedBasket}
                                handleAddToCartFromSavedBasket={handleAddToCartFromSavedBasket}
                            />)}
                    </div>
                </div>
            </div>

            <div className="row">
                <OtherProducts
                    product={product}
                    productWidth={productWidth}
                />
            </div>
        </div>)
    }
    else {
        return (
            <div className='newProduct align-items-center' ref={productRef} style={{ borderColor: borderColor }}>
                <div className="row">
                    {generateFirstModule()}
                    <div className="col-2 align-items-center">
                        <div className='newProduct-img p-2' onClick={() => handleProductRedirect(product.index, isAvailabilityLevelAdditionalInfoShowed, activeCategory)} style={{ cursor: 'pointer' }}>
                            <GetProductImage
                                photoFileName={product.photoFileNames[0]}
                            />
                        </div>
                    </div>
                    <div className="col">
                        <div className="d-flex">
                            <span className='light-text-color'>{getProductIndexWithMask(product.index)}</span>
                            <NewPromoSellOutTag
                                product={product}
                                isBigTag={false}
                            />
                        </div>
                        <div className="row mt-2">
                            <div className="col d-flex flex-column element-pointer" onClick={() => handleProductRedirect(product.index, isAvailabilityLevelAdditionalInfoShowed, activeCategory)}>
                                <span>{CapitalizeFirstLowercaseRest(product.title)}</span>
                                <span className='secondary-text mt-2' style={{ minHeight: '70px' }}>{CapitalizeFirstLowercaseRest(product.label)}</span>
                            </div>
                            <div className="col-3">
                                <ProductThreshold
                                    product={product}
                                    isProductDetail={false}
                                />
                            </div>
                            <div className="col-4">
                                <div className='d-flex flex-column'>
                                    {orderItemsFromOffer && orderItemsFromOffer.length > 0 ?
                                        (<ProductBuyBtnForRealizedOffer
                                            product={product}
                                        />)
                                        :
                                        (<ProductBuyBtn
                                            product={product}
                                            quantityInCart={quantityInCart}
                                            quantity={quantity}
                                            setQuantity={setQuantity}
                                            OnChange={OnChange}
                                            onClick={handleBtnOnClick}
                                            isBasketSummary={isBasketSummary}
                                            isProductDetail={false}
                                            blockSetPriceFromBasket={blockSetPriceFromBasket}
                                            isSavedBasket={isSavedBasket}
                                            handleAddToCartFromSavedBasket={handleAddToCartFromSavedBasket}
                                        />)}
                                </div>
                            </div>
                        </div>
                    </div>
                    {additionalOptions && (
                        <div className="col-auto d-flex align-items-center me-2">
                            <RxCross2 size={25} style={{ cursor: 'pointer' }} onClick={() => handleRemoveButtonClick()} />
                        </div>
                    )}
                </div>


                <div className="row">
                    <div className='col-auto'>{<MdOutlineKeyboardArrowUp size={10} className='hidden' />}</div> {/* tylko po to aby zajmować miejsce i wyrównać elementy */}
                    <div className="col-2" />
                    <div className="col d-flex">
                        <span className='light-text-color me-2'>Producent</span>
                        <span>{producerText}</span>
                        <div className='ms-5'>
                            <ProductAvailabilityLevel
                                product={product}
                                setIsAvailabilityLevelAdditionalInfoShowed={setIsAvailabilityLevelAdditionalInfoShowed}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <OtherProducts
                        product={product}
                        productWidth={productWidth}
                    />
                </div>
            </div>
        )
    }
}

export default Product